import { Host, h } from '@stencil/core';
var WEATHER_VARIATIONS;
(function (WEATHER_VARIATIONS) {
  WEATHER_VARIATIONS["LOADING"] = "loading";
  WEATHER_VARIATIONS["ENABLE_FORM"] = "enableForm";
  WEATHER_VARIATIONS["INVALID_POSTAL_CODE"] = "invalidPostCode";
  WEATHER_VARIATIONS["SHOW_WEATHER_DATA"] = "showWeatherData";
})(WEATHER_VARIATIONS || (WEATHER_VARIATIONS = {}));
export class AibaResultScreen {
  constructor() {
    this.renderWeatherBlock = (component) => {
      switch (this.weatherVariation) {
        case WEATHER_VARIATIONS.LOADING:
          return h("aiba-weather-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers, loading: true, variation: this.weatherVariation }));
        case WEATHER_VARIATIONS.ENABLE_FORM:
          return h("aiba-weather-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers, enableForm: true, variation: this.weatherVariation }));
        case WEATHER_VARIATIONS.INVALID_POSTAL_CODE:
          return h("aiba-weather-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers, enableForm: false, invalidPostCode: true, variation: this.weatherVariation }));
        case WEATHER_VARIATIONS.SHOW_WEATHER_DATA:
          return (h("aiba-weather-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers, enableForm: false, invalidPostCode: false, weatherData: this.weatherData, variation: this.weatherVariation })));
        default:
          return null;
      }
    };
    this.getData = undefined;
    this.handlers = undefined;
    this.layouts = undefined;
    this.data = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.weatherVariation = undefined;
    this.hideNewsLetterOnAuthentication = false;
  }
  updateWeatherVariation(event) {
    this.weatherVariation = event.detail ? event.detail : '';
  }
  async componentWillLoad() {
    if (this.getData) {
      const mainData = await this.getData();
      this.data = mainData === null || mainData === void 0 ? void 0 : mainData.data;
    }
    if (this.handlers && this.handlers.handleWeatherBlockOnLoad && this.handlers.getWeatherVariationState) {
      if (!this.weatherData) {
        const weathData = await this.handlers.handleWeatherBlockOnLoad();
        if ((weathData === null || weathData === void 0 ? void 0 : weathData.location) && (weathData === null || weathData === void 0 ? void 0 : weathData.weather))
          this.weatherData = weathData;
      }
      if (!this.weatherVariation) {
        const weathVariation = await this.handlers.getWeatherVariationState();
        if (weathVariation)
          this.weatherVariation = weathVariation;
      }
    }
    if (this.handlers && this.handlers.handleResultScreenOnLoad) {
      const { hideNewsLetterOnAuthentication } = await this.handlers.handleResultScreenOnLoad();
      this.hideNewsLetterOnAuthentication = hideNewsLetterOnAuthentication;
    }
    if (this.handlers && this.handlers.handleResultScreenOnLoadData) {
      const data = await this.handlers.handleResultScreenOnLoadData(this.data);
      if (data) {
        this.data = data;
      }
    }
  }
  async componentDidLoad() {
    if (this.handlers && this.handlers.handleResultDidLoad) {
      await this.handlers.handleResultDidLoad();
    }
  }
  async componentDidUpdate() {
    if (this.handlers && this.handlers.handleResultDidUpdate) {
      await this.handlers.handleResultDidUpdate();
    }
  }
  async componentWillRender() {
    if (this.handlers && this.handlers.handleWeatherBlockOnLoad) {
      const weathData = await this.handlers.handleWeatherBlockOnLoad();
      if ((weathData === null || weathData === void 0 ? void 0 : weathData.location) && (weathData === null || weathData === void 0 ? void 0 : weathData.weather))
        this.weatherData = weathData;
    }
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), h("section", { class: `result-screen` }, this.data &&
      this.data.map((component) => {
        if (component && component['name'] === 'aiba-navigation-block' && component['id'] === 'backtostyle')
          return h("aiba-navigation-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-weather-block')
          return this.weatherVariation && this.renderWeatherBlock(component);
        if (component && component['name'] === 'aiba-tabs')
          return h("aiba-tabs", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-recommended-products')
          return h("aiba-recommended-products", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-recommended-products-tab')
          return h("aiba-recommended-products-tab", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-recommended-products-for-tabs')
          return h("aiba-recommended-products-for-tabs", Object.assign({}, component, { sectionId: component['id'] ? component['id'] : '', handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-user-accordian')
          return h("aiba-user-accordian", { data: component['data'], handlers: this === null || this === void 0 ? void 0 : this.handlers });
        if (component && component['name'] === 'aiba-analysis-result')
          return h("aiba-analysis-result", { data: component['data'], handlers: this === null || this === void 0 ? void 0 : this.handlers });
        if (component && component['name'] === 'aiba-navigation-block' && component['id'] !== 'pdf-mailer' && component['id'] !== 'backtostyle')
          return h("aiba-navigation-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-navigation-block' && this.hideNewsLetterOnAuthentication && component['id'] === 'pdf-mailer')
          return h("aiba-navigation-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-generic-block')
          return h("aiba-generic-block", { data: component && component['data'], _id: component['_id'] ? component['_id'] : '', handlers: this === null || this === void 0 ? void 0 : this.handlers });
        if (component && component['name'] === 'aiba-newsletter' && !this.hideNewsLetterOnAuthentication)
          return h("aiba-newsletter", { data: component && component['data'], handlers: this === null || this === void 0 ? void 0 : this.handlers });
        if (component && component['name'] === 'aiba-recommended-articles')
          return h("aiba-recommended-articles", { data: component && component['data'], handlers: this === null || this === void 0 ? void 0 : this.handlers });
        if (component && component['name'] === 'aiba-selfie-compare-results-wrapper') {
          return h("aiba-selfie-compare-results-wrapper", { data: component && component['data'], handlers: this === null || this === void 0 ? void 0 : this.handlers });
        }
        if (component && component['name'] === 'aiba-analysis-graph-view') {
          return h("aiba-analysis-graph-view", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        }
      }))));
  }
  static get is() { return "aiba-result-screen"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-result-screen.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-result-screen.css"]
    };
  }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "layouts": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "layouts",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {},
      "weatherVariation": {},
      "hideNewsLetterOnAuthentication": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-weather-variation-changed",
        "method": "updateWeatherVariation",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-result-screen.js.map
